<div
  [hidden]="myInitial == ''"
  style="width: 100%; padding: 10px 0px 6px 0px; text-align: center"
>
  <svg width="40" height="40" (click)="clickProfile()" style="cursor: pointer">
    <circle cx="20" cy="20" r="20" fill="var(--colorAli)" />
    <text
      x="20"
      y="20"
      text-anchor="middle"
      dominant-baseline="middle"
      fill="white"
      font-size="18"
    >
      {{ myInitial }}
    </text>
  </svg>
</div>

<!--
<div style="display:flex; flex-direction: column; align-items: center; " [hidden]="myInitial == ''">
    <div id="profileButton" style="display: flex;" title="{{myName}}">{{myInitial}}</div>
    <div style="display:flex;"></div>    
</div>
-->
